import React from "react";

import { Chip, useTheme } from "@mui/material";
import clsx from "clsx";
import mainStyles from "styles";

interface ActiveStatusChipProps {
  active: boolean | undefined;
}

const ActiveStatusChip = ({ active }: ActiveStatusChipProps) => {
  const classes = mainStyles();
  const theme = useTheme();

  if (active === undefined) {
    return <></>;
  }

  return (
    <>
      <Chip
        size="small"
        color={active ? "success" : "default"}
        className={clsx(classes.spaceRightXSmall)}
        style={{
          fontWeight: "bold",
          marginBottom: "3px",
          color: active
            ? theme.palette.success.contrastText
            : theme.palette.text.primary,
        }}
        label={`${active ? "Active" : "Deactivated"}`}
        data-testid="active-status-chip"
      />
    </>
  );
};

export default ActiveStatusChip;
